__turbopack_context__.v({
  "desktop": "utilities-module-scss-module__UGK_TG__desktop",
  "desktopFlex": "utilities-module-scss-module__UGK_TG__desktopFlex",
  "mobile": "utilities-module-scss-module__UGK_TG__mobile",
});
